import { render, staticRenderFns } from "./sub-station-install.vue?vue&type=template&id=2fb3fcac"
import script from "./sub-station-install.vue?vue&type=script&lang=js"
export * from "./sub-station-install.vue?vue&type=script&lang=js"
import style0 from "./sub-station-install.vue?vue&type=style&index=0&id=2fb3fcac&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports